export enum LayerType {
  WMS = 'WMS',
  WFS = 'WFS',
  ShapeFile = 'SHP',
  KML = 'KML',
  CSV = 'CSV',
}
